import { StrictMode, type ReactNode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";
import { currentAccount, signIn } from "./auth/msal.js";
import { SiteHeader } from "./components/SiteHeader.js";
import "./styles/tokens.css";
import "./styles/base.css";

const el = document.getElementById("root");
if (el) {
  const root = createRoot(el);
  const render = (node: ReactNode) => root.render(<StrictMode>{node}</StrictMode>);

  const message = (title: string, text: string) => (
    <>
      <SiteHeader title="Ask HR" />
      <main className="wrap">
        <section className="panel">
          <h2>{title}</h2>
          <p className="sub">{text}</p>
        </section>
      </main>
    </>
  );

  // Nothing of Ask HR shows until sign-in is settled: someone who isn't signed in goes straight
  // to Microsoft from a blank page, rather than glimpsing the app first. Only a slow start (the
  // return from Microsoft can take a moment) gets a plain "Signing you in" note, with no header.
  const slow = setTimeout(
    () =>
      render(
        <main className="wrap">
          <p className="sub signing-in">Signing you in…</p>
        </main>,
      ),
    1500,
  );
  currentAccount()
    .then((account) => {
      if (!account) return signIn();
      clearTimeout(slow);
      render(<App account={account} />);
    })
    .catch(() => {
      clearTimeout(slow);
      render(
        message(
          "Couldn't sign you in",
          "Reload the page to try again. If it keeps happening, you may not have access to Ask HR yet; ask IT.",
        ),
      );
    });
}
